import { Box } from "@mui/material";
import { DateRangeQuickFilters } from "../../components/ui/dateRangeFilter/dateRangeQuickFilters.component";

export const GeneralStatsActions = () => (
  <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <DateRangeQuickFilters />
  </Box>
);
